import { take, fork, all } from 'redux-saga/effects';
import { apiTask, watchApiTask } from '../../app/sagas';
import { api } from '../../app/api';
import * as actions from './simulatedCorrectionActions';

export const removeAnswerSheetTask = watchApiTask(
  actions.REMOVE_ANSWER_SHEET,
  api.post,
  '/evaluation-system/removeAnswerSheet.php',
);

export const getEvaluationInformationTask = watchApiTask(
  actions.GET_EVALUATION_INFORMATION,
  api.post,
  '/evaluation-system/getEvaluationInformation.php',
);

export const getStudentAnswerDetailTask = watchApiTask(
  actions.GET_STUDENT_ANSWER_DETAIL,
  api.post,
  '/evaluation-system/getStudentAnswerDetail.php',
);

export const correctAnswerSheetTask = watchApiTask(
  actions.CORRECT_ANSWER_SHEET,
  api.post,
  '/evaluation-system/correctAnswerSheet.php',
);

export const getStudentAnswerListTask = watchApiTask(
  actions.GET_STUDENT_ANSWER_LIST,
  api.post,
  '/evaluation-system/getStudentAnswerList.php',
);

export const updateAnswerSheetTask = watchApiTask(
  actions.UPDATE_ANSWER_SHEET,
  api.post,
  '/evaluation-system/updateAnswerSheet.php',
);

export const addAnswerSheetTask = watchApiTask(
  actions.ADD_ANSWER_SHEET,
  api.post,
  '/evaluation-system/addAnswerSheet.php',
);

export const finalizeEvaluationTask = watchApiTask(
  actions.FINALIZE_EVALUATION,
  api.post,
  '/evaluation-system/finalizeEvaluation.php',
);
// Root module saga
export function* sagas() {
  yield all([
    fork(correctAnswerSheetTask),
    fork(getEvaluationInformationTask),
    fork(getStudentAnswerListTask),
    fork(getStudentAnswerDetailTask),
    fork(removeAnswerSheetTask),
    fork(updateAnswerSheetTask),
    fork(addAnswerSheetTask),
    fork(finalizeEvaluationTask),
  ]);
}
